// Import and auto-register all content cards
import './BlogCard';
import './ImageCard';
import './LinkCard';
import './GuestLoginCard';
import './ShareSuggestionsCard';
import './MembershipCard';
// Register openProduct and openStory handlers
import '@/lib/ambient-intelligence/handlers/OpenContentActionHandler';
// Register share handler
import '@/lib/ambient-intelligence/handlers/ShareActionHandler';
// Register membership handlers
import '@/lib/ambient-intelligence/handlers/MembershipActionHandler';

import { ContentRegistry } from '../registries';
// Import enhanced product card and register it
import ProductCardEnhanced from './ProductCardEnhanced';

// Register the enhanced product card
ContentRegistry.register('product', ProductCardEnhanced);

// Export components for direct use if needed
export { default as BlogCard } from './BlogCard';
export { default as ProductCard } from './ProductCardEnhanced'; // Export enhanced version
export { default as ImageCard } from './ImageCard';
export { default as LinkCard } from './LinkCard';
export { default as GuestLoginCard } from './GuestLoginCard';
export { default as ShareSuggestionsCard } from './ShareSuggestionsCard';
export { default as MembershipCard } from './MembershipCard';

console.log('✨ Content cards registered with ContentRegistry');
console.log('🔍 Registered content types:', ContentRegistry.getRegisteredTypes());
console.log('🔍 Has conversation renderer:', ContentRegistry.hasRenderer('conversation'));
